import React, { Component } from 'react'
import { connect } from 'react-redux'
import Sidebar from '../common/Sidebar'
import Header from '../common/Header'
import classNames from 'classnames'

/*
  this components should render sidebar, header, footer
  and a child which is provided by the router (react-router V3)
  these child elements are containers themselves
  accessing this component needs authentication
  this component also determines any customization
  for each user type, child components shouldn't
  decide that, just receive it via props
*/

class DashboardContainer extends Component {
  constructor() {
    super()
    this.state = {}
  }

  shouldShowMainContent = () => {
    if (!this.props.onMobileBrowser) return true
    return !this.props.sideBarIsOpen
  }

  render() {
    const props = {
      id: 'dashboard-core',
      className: classNames({
        'pushed-menu': this.props.sideBarIsOpen,
        'is-mobile': this.props.onMobileBrowser,
      }),
    }

    return (
      <div id="main-content-dashboard">
        <Sidebar />

        <div {...props}>
          <Header />

          {/* when side bar is open hide the main section in small devices */}
          <section
            id="dashboard-route"
            className={classNames({ hide: !this.shouldShowMainContent() })}
          >
            {this.props.children}
          </section>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    mediumBrowser: state.browser.lessThan.large,
    onMobileBrowser: state.browser.lessThan.small,
    sideBarIsOpen: state.sidebar.isOpen,
  }
}

export default connect(mapStateToProps)(DashboardContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardContainer.js